import {Barcode} from 'scandit-react-native-datacapture-barcode';

// eslint-disable-next-line no-shadow
export enum ScannerMode {
  singleScan = 'singleScan',
  singleSelectScan = 'singleSelectScan',
  singleAutoScan = 'singleAutoScan',
  continuousScan = 'continuousScan',
  matrixScan = 'matrixScan',
  continuousSingleScan = 'continuousSingleScan',
}
export type ScannerProps =
  | {
      mode: ScannerMode.matrixScan;
      onScan: (barcodes: Barcode[]) => void;
      expectedBarcodes?: string[];
      showBubbles?: boolean;
    }
  | {
      mode: ScannerMode.singleScan;
      onScan: (barcode: FlatBarcode, imageBase64: string) => void;
      showOrganicDetails?: boolean;
      organicItemQuantity?: number;
      expectedBarcodes?: string[];
    }
  | {
      mode: ScannerMode.singleSelectScan | ScannerMode.singleAutoScan;
      onScan: (barcode: Barcode, imageBase64: string) => void;
      showOrganicDetails?: boolean;
      organicItemQuantity?: number;
      expectedBarcodes?: string[];
    }
  | {
      mode: ScannerMode.continuousScan;
      onScan: (barcode: Barcode, allScanned?: boolean) => void;
      expectedBarcodes?: string[];
      scannedBarcodes: string[];
    }
  | {
      mode: ScannerMode.continuousSingleScan;
      onScan: (barcode: Barcode) => void;
    };

export type CommonScannerProps = {
  scannerEnabled: boolean;
  setScannerEnabled: (val: boolean) => void;
  triggerAddAnother?: boolean;
};

export type ParentScannerProps = CommonScannerProps & ScannerProps;

export interface SingleScanProps extends Omit<ParentScannerProps, 'mode'> {
  onScan: (barcode: FlatBarcode, imageBase64?: string) => void;
  expectedBarcodes?: string[];
}

export interface SingleSelectScanProps
  extends Omit<ParentScannerProps, 'mode' | 'onScan'> {
  onScan: (barcode: Barcode, imageBase64?: string) => void;
  expectedBarcodes?: string[];
}

export interface ContinuousScanProps
  extends Omit<ParentScannerProps, 'mode' | 'onScan'> {
  onScan: (barcode: Barcode, allScanned?: boolean) => void;
  expectedBarcodes?: string[];
}

export interface MatrixScanProps
  extends Omit<ParentScannerProps, 'mode' | 'onScan'> {
  onScan: (barcode: Barcode[]) => void;
  expectedBarcodes?: string[];
  showBubbles?: boolean;
}

export interface ScannerRef {
  retryScan: () => void;
}

// eslint-disable-next-line no-shadow
export enum SelectionType {
  tap = 'tap',
  aim = 'aim',
}

export const COMMAND_START_CAPTURE = 'startCapture';
export const COMMAND_STOP_CAPTURE = 'stopCapture';

export interface FlatBarcode {
  data: string | null;
  symbology?: string;
}
